import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { DayInterface } from "../interfacesAndTypes";
import Day from "./Day";
import VideoModal from "./VideoModal";
import classes from "*.module.css";
import Avatar from "@material-ui/core/Avatar";
import { deepOrange, green } from "@material-ui/core/colors";
import AssignmentIcon from "@material-ui/icons/Assignment";

interface LecturesTablePropsInterface {
  days: DayInterface[];
}
const useStyles = makeStyles({
  root: {
    maxWidth: "715px",
    margin: "0 auto",
  },
  center: { textAlign: "center" },
  roundedImage: {
    color: "#fff",
    width: "150px",
    height: "200px",
    backgroundColor: "#ececec",
  },
});

const Row = (props: {
  day: DayInterface;
  classes: Record<"center" | "roundedImage", string>;
  inputOpen: string | undefined;
}) => {
  const { day, classes, inputOpen } = props;

  const [open, setOpen] = useState(inputOpen === "1" ? true : false);
  const [videoPlayerOpen, setVideoPlayerOpen] = useState(false);
  const [video, setVideo] = useState({ src: "", title: "", topic: "" });
  useEffect(() => {
    if (video.src) {
      setVideoPlayerOpen(true);
    }
  }, [video]);
  return (
    <>
      <TableRow>
        <TableCell style={{ width: "30px" }}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell component="th" scope="row">
          <Avatar variant="rounded" className={classes.roundedImage}>
            <a href={day.poster || "/images/no-poster.png"}>
              <img
                width="150px"
                height="auto"
                src={day.poster || "/images/no-poster.png"}
                alt="program poster"
              />
            </a>
          </Avatar>
        </TableCell>
        <TableCell component="th" scope="row">
          <div className={classes.center}>
            <Link
              href="#"
              color="inherit"
              onClick={(event: React.SyntheticEvent) => {
                event.preventDefault();
                setOpen(!open);
              }}
            >
              <Typography component="h6" variant="h6">
                {day.name /* program name */}
              </Typography>
            </Link>
          </div>
          <div className={classes.center}>
            <Link
              href="#"
              color="inherit"
              onClick={(event: React.SyntheticEvent) => {
                event.preventDefault();
                setOpen(!open);
              }}
            >
              {day.date}
            </Link>
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Day day={day} video={video} setVideo={setVideo} />
          </Collapse>
        </TableCell>
      </TableRow>
      <VideoModal
        open={videoPlayerOpen}
        setOpen={setVideoPlayerOpen}
        title={video.title}
        topic={video.topic}
        src={video.src}
      />
    </>
  );
};

export default function LecturesTable(props: LecturesTablePropsInterface) {
  const { days } = props;
  const classes = useStyles();

  return (
    <TableContainer component={Paper} className={classes.root}>
      <Table aria-label="collapsible table">
        <TableBody>
          {days.map((day) => (
            <Row
              key={day.key}
              day={day}
              classes={classes}
              inputOpen={day.open}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
